<template>
  <div>
    <div class="toolbar">
      <el-input
        v-model="keyword"
        clearable
        placeholder="收货单号"
        style="width:200px"
        @keyup.enter.native="load"
      />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="receiveNo" label="收货单号" width="160" show-overflow-tooltip />
      <el-table-column prop="reqNo" label="申请单号" width="160" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.reqNo || '-' }}</template>
      </el-table-column>
      <el-table-column prop="projectName" label="项目" min-width="140" show-overflow-tooltip />
      <el-table-column prop="createdByName" label="收货人" width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.createdByName || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createdByPhone" label="联系电话" width="120">
        <template slot-scope="{ row }">{{ row.createdByPhone || '-' }}</template>
      </el-table-column>
      <el-table-column label="收货时间" width="120">
        <template slot-scope="{ row }">{{ fmtDate(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="90" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-drawer title="收货单详情" :visible.sync="detailVisible" size="560px">
      <div v-if="detail" style="padding:0 16px 16px">
        <p>收货单号：{{ detail.receive.receiveNo }}</p>
        <p>申请单号：{{ detail.receive.reqNo || '-' }}</p>
        <p>项目：{{ detail.receive.projectName }}</p>
        <p>
          收货人：{{ detail.receive.createdByName || '-' }}
          · {{ detail.receive.createdByPhone || detail.createdByPhone || '-' }}
          · {{ fmtDate(detail.receive.createdAt) }}
        </p>
        <p v-if="detail.receive.remark">备注：{{ detail.receive.remark }}</p>
        <el-table :data="detail.lines" border size="small" style="margin-top:12px">
          <el-table-column prop="materialName" label="材料" min-width="140" />
          <el-table-column prop="unit" label="单位" width="70" />
          <el-table-column prop="reqQty" label="申请数量" width="90" />
          <el-table-column prop="alreadyQty" label="此前已收" width="90" />
          <el-table-column prop="receiveQty" label="本次收货" width="90" />
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { listMaterialReceives, getMaterialReceive } from '../../api/supply'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'SupplierReceive',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      keyword: '',
      list: [],
      loading: false,
      detailVisible: false,
      detail: null
    }
  },
  created() {
    this.load()
  },
  methods: {
    fmtDate(v) {
      if (!v) return '-'
      return String(v).slice(0, 10)
    },
    async load() {
      this.loading = true
      try {
        const res = await listMaterialReceives({
          keyword: this.keyword || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async openDetail(row) {
      const res = await getMaterialReceive(row.id)
      this.detail = res.data
      if (this.detail && this.detail.receive && !this.detail.receive.createdByPhone) {
        this.detail.createdByPhone = row.createdByPhone
      }
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
</style>
